export interface ExperienceItem {
  company: string;
  position: string;
  fromDate: string;
  toDate: string;
}

export interface ProjectItem {
  name: string;
  href: string;
  role: string;
  stack: string[];
  fromDate: string;
  toDate: string;
}

export const experience = (): ExperienceItem[] => {
  return [
    {
      company: "Raiinmaker",
      position: "Full Stack Developer",
      fromDate: "April 2021",
      toDate: "Jan 2025"
    },
    {
      company: "Zignaly",
      position: "Full Stack Developer",
      fromDate: "April 2020",
      toDate: "June 2021"
    },
    {
      company: "Latency Esports",
      position: "Frontend Developer",
      fromDate: "November 2019",
      toDate: "March 2020"
    },
    {
      company: "HireNinja",
      position: "Full Stack Developer",
      fromDate: "June 2018",
      toDate: "Dec 2019"
    },
    {
      company: "Software Productivity Strategist",
      position: "Frontend Developer",
      fromDate: "October 2017",
      toDate: "April 2018"
    },
    {
      company: "Freelancing",
      position: "Full Stack Developer",
      fromDate: "April 2016",
      toDate: "Aug 2019"
    }
  ];
};

export const stack = (): string[] => {
  return [
    "ReactJS",
    "VueJS",
    "NodeJS",
    "NextJS",
    "GatsbyJS",
    "HTML",
    "Javascript",
    "CSS",
    "Material UI",
    "Element UI",
    "Ant Design",
    "Vuetify",
    "MongoDB",
    "Mongoose",
    "MySQL",
    "PostGreSQL",
    "PHP",
    "Laravel/Lumen",
    "Git",
    "Github",
    "TypeScript",
    "Eloquent",
    "GoLang",
    "REST",
    "Sequalize",
    "GraphQL",
    "Web3JS",
    "Solidity",
    "Smart Contracts",
    "Blockchain",
    "Docker",
    "AWS",
    "Kubernetes",
    "AWS S3",
    "AWS EKS",
    "AWS RDS"
  ];
};

export const projects = (): ProjectItem[] => {
  return [
    {
      name: "Raiinmaker",
      href: "https://app.raiinmaker.com",
      role: "Full Stack Developer",
      stack: [
        "Typescript",
        "RaactJS",
        "MaterialUI",
        "GatsbyJS",
        "NodeJS",
        "PostgreSQL",
        "Redux",
        "Redux-Thunk",
        "Responsive Layout",
        "GraphQL",
        "REST API",
        "TS.ED",
        "Web Socket",
        "Redis",
        "AWS",
        "AWS, RDS",
        "AWS EKS",
        "Docket",
        "AWS S3"
      ],
      fromDate: "April 2022",
      toDate: "Jan 2025"
    },
    {
      name: "Zignaly",
      href: "https://zignaly.com/app/login/",
      role: "Full Stack Developer",
      stack: [
        "Html",
        "CSS",
        "Javascript",
        "MaterialUI",
        "GatsbyJS",
        "PHP",
        "MongoDB",
        "ReactJS",
        "Redux",
        "Redux-Thunk",
        "Responsive Layout"
      ],
      fromDate: "April 2020",
      toDate: "Present"
    },
    {
      name: "Pinging",
      href: "https://pingingapp.com/agenda",
      role: "Frontend Developer",
      stack: ["Html", "CSS", "Javascript", "MaterialUI", "ReactJS", "Redux", "Redux-Thunk", "Sockets", "FeatherJS", "Responsive Layout"],
      fromDate: "November 2019",
      toDate: "Present"
    },
    {
      name: "Luminary",
      href: "http://luminary.audio/",
      role: "Frontend Developer",
      stack: ["Html", "CSS", "Javascript", "ElementUI", "VueJS", "VueX", "Responsive Layout"],
      fromDate: "August 2018",
      toDate: "April 2019"
    },
    {
      name: "Hireninja",
      href: "http://hireninja.com/",
      stack: ["Html", "CSS", "Javascript", "ElementUI", "VueJS", "VueX", "Responsive Layout"],
      role: "Full Stack Developer",
      fromDate: "June 2018",
      toDate: "Dec 2019"
    },
    {
      name: "FoodFactory",
      href: "https://ffoperations.com/login",
      stack: ["Html", "CSS", "Javascript", "MaterialUI", "NodeJS", "MongoDB", "Mongoose", "ReactJS", "Redux", "Redux-Thunk"],
      role: "Full Stack Developer",
      fromDate: "November 2020",
      toDate: "December 2020"
    }
  ];
};
